import { SxProps, Theme } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { TabVariant } from "./tab";

interface TabStyleOptions {
  selected?: boolean;
  hasIcon?: boolean;
}

type TabStyleMap = {
  [key in TabVariant]: (options: TabStyleOptions) => SxProps<Theme>;
};

const baseTabStyles = (selected: boolean = false): SxProps<Theme> => ({
  cursor: "pointer",
  position: "relative",
  ...nawyTheme.nawy.typography.english.variants.body.md.regular,
  color: selected
    ? nawyTheme.nawy.colors.semantic.text.accent
    : nawyTheme.nawy.colors.semantic.text.primary,
  transition: "all 0.2s cubic-bezier(0.2, 0, 0, 1)",
  "&:hover": {
    color: nawyTheme.nawy.colors.semantic.text.accent,
  },
  "&:active": {
    color: nawyTheme.nawy.colors.semantic.text.accent,
  },
});

export const tabStyleMap: TabStyleMap = {
  primary: ({ selected = false }) => ({
    ...baseTabStyles(selected),
    height: nawyTheme.nawy.spacing["3xl"],
    paddingX: nawyTheme.nawy.spacing.md,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  secondary: ({ selected = false }) => ({
    ...baseTabStyles(selected),
    paddingX: nawyTheme.nawy.spacing.md,
    paddingY: nawyTheme.nawy.spacing.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: nawyTheme.nawy.spacing.xs,
  }),
};

export const tabContentStyles = (
  variant: TabVariant,
  hasIcon: boolean
): SxProps<Theme> =>
  variant === "primary"
    ? {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2px",
        paddingY: nawyTheme.nawy.spacing.sm,
        paddingTop: hasIcon ? "10px" : nawyTheme.nawy.spacing.sm,
      }
    : {};

export const tabIndicatorStyles = (
  variant: TabVariant,
  selected: boolean
): SxProps<Theme> =>
  variant === "primary"
    ? {
        position: "absolute",
        bottom: "-1px",
        left: nawyTheme.nawy.spacing.md,
        right: nawyTheme.nawy.spacing.md,
        height: nawyTheme.nawy.spacing.xxs,
        backgroundColor: nawyTheme.nawy.colors.semantic.text.accent,
        borderRadius: `${nawyTheme.nawy.radius.full} ${nawyTheme.nawy.radius.full} 0 0`,
        opacity: selected ? 1 : 0,
        transition: "opacity 0.2s cubic-bezier(0.2, 0, 0, 1)",
      }
    : {
        position: "absolute",
        bottom: "-1px",
        left: 0,
        right: 0,
        height: nawyTheme.nawy.spacing.xxxs,
        backgroundColor: nawyTheme.nawy.colors.semantic.text.accent,
        opacity: selected ? 1 : 0,
        transition: "opacity 0.2s cubic-bezier(0.2, 0, 0, 1)",
      };
